import React, { useEffect, useState } from "react";
import systemListingService from "./SystemListingServices";
import Pagination from "components/Common/newPagination";
import FormatCodeUpsert from "./upsert/FormatCodeUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function FormatCode(param: any) {
  const [query, setQuery] = useState("");
  const [showDims, setShowDims] = useState(false);
  let [editDawer, setEditDawer] = useState<any>(false);
  const [editingOn, setEditingOn] = useState<boolean>(false);
  const [editDataDawer, setEditDataDawer] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<any>("Recorded Music");
  let [formatCodeListing, SetFormatCodeListing] = useState<any>([]);
  let [tempformatCodeListing, SetTempFormatCodeListing] = useState<any>([]);
  let [formatCount, setFormatCount] = useState<number>(0);

  useEffect(() => {

    if (param.activeTab === "Format / Source Codes") {
      formatCodeSelect("Recorded Music")
    }
  }, [param])

  const formatCodeSelect = (formatCode: any) => {
    setActiveTab(formatCode)
    console.log(formatCode)

    formatCount = 0
    setFormatCount(formatCount)

    const payload = {
      filter: formatCode === "Recorded Music" ? "sales" : "publishing",
    };

    systemListingService.getAllFormatCodeByParentGroup(payload).then((respond) => {
      SetTempFormatCodeListing(respond);
      formatCodeListing = respond.slice((1 - 1) * 10, (10 * 1));
      SetFormatCodeListing(formatCodeListing)
      formatCount = respond.length;
      setFormatCount(formatCount);

    });
  };

  const openAddDrawer = (code: any) => {
    if (code) {
      setEditDataDawer(code)
    }
    editDawer = true
    setEditDawer(editDawer);
    console.log(editDawer)

  };

  const closeDrawer = () => {
    editDawer = false
    setEditDawer(editDawer);
    console.log(editDawer)
  };

  const openEditDrawer = (row: any) => {
    if (row) {
      setEditDataDawer(row)
    }
    editDawer = true
    setEditDawer(editDawer);
    console.log(editDawer)

  };

  const onPageChange = (payLoad: any) => {
    console.log(payLoad)

    formatCodeListing = tempformatCodeListing.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber);
    SetFormatCodeListing(formatCodeListing)
  }

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    console.log(deleteData)
    if (e == 1) {
      systemFormatsList.deleteFormatCodes(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Format Code delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const csvFormatHeadersRaw = function (type: any) {
    systemListingService.formatCodeExport({ filter: type == 'Publishing' ? 'publishing' : 'sales' })
  };

  return (
    <>

      <div className="content-card ws-12">
        {/* Header */}
        <div className="ws-12">
          <div className="card-title">Format / Source Codes</div>

          {/* Tabs */}
          <div className="ws-12">
            <div className="nav nav-tabs nav-justified p0 m0 pt pb ws-9">
              <button className={"icon-btn edit " + (activeTab === "Recorded Music" ? "fill" : "")} onClick={() => { setActiveTab("Recorded Music"); formatCodeSelect("Recorded Music"); }}>
                Recorded Music
              </button>

              <button className={"icon-btn edit " + (activeTab === "Publishing" ? " fill" : "")} onClick={() => { setActiveTab("Publishing"); formatCodeSelect("Publishing"); }}>
                Publishing
              </button>
            </div>

            <div className="ws-3">
              <button className="icon-btn primary fill pull-right" type="button" disabled={!editingOn} onClick={() => openAddDrawer({})}  >
                Add Format Code
              </button>

              <div className="hover-box m0 ml pull-right">
                <button className="icon-btn primary height35"> <i className="icon-download1"></i></button>
                <div className="hover-block mtxl">
                  <a className="icon-btn info btn-sm text-s mt" onClick={() => csvFormatHeadersRaw(activeTab)} >Export {activeTab}</a>
                  <a className="icon-btn info btn-sm text-s mt hide" onClick={() => csvFormatHeadersRaw("all")}>Export All</a>
                </div>
              </div>

            </div>

          </div>

          <div className="ws-12 mb">
            <span className="pt mt pull-left">{formatCount} record(s) found  </span>
            <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>
          </div>
        </div>

        {/* Filter */}
        <div className="ws-12 pm mbxl" style={{ borderRadius: 8, border: "1px solid #e5e7eb" }}  >

          <div className="ws-6">
            <div className="ws-12 text-bold pbl">Filter</div>
            <input className="ws-10"placeholder="Search by code, format, parent group…" value={query} onChange={(e) => { setQuery(e.target.value); }} style={{ minWidth: 420 }} />
            <button className="icon-btn primary" type="button">  Search  </button>
          </div>

          {/* DIM Columns toggle */}
          <div className="ws-6" >
            <div className="ws-12 text-bold text-m text-right">DIM Columns</div>

            <label className="switch mtl pull-right">
              <input type="checkbox" name="showDims" checked={showDims} onClick={() => setShowDims((prev) => !prev)} />
              {showDims && <span className="slider round text-left white pm pts" >Yes</span>}
              {!showDims && <span className="slider round text-right white pm pts sliderOff">No</span>}
            </label>

          </div>

        </div>

        {/* Table */}
        <div className="allowHscroll ws-12">
          {formatCount > 0 && <table className={editingOn ? "editing-on newTable" : "newTable"}>
            <thead>
              <tr className="forceSingleLine">
                <th >Code</th>
                {!showDims && <th >Format/Source Code</th>}
                {!showDims && <th >Part Format</th>}
                {!showDims && <th >Mechanicals</th>}
                {!showDims && <th >Cat Format</th>}
                {!showDims && <th >Cat Format Code</th>}
                {!showDims && <th >Parent Group</th>}
                {!showDims && <th >Format Report</th>}
                {!showDims && <th >Esc Rate Album</th>}
                {!showDims && <th >Esc Rate Track</th>}
                {!showDims && <th >Operation</th>}

                {showDims && <th >Code</th>}
                {showDims && <th >DIM1</th>}
                {showDims && <th >DIM2</th>}
                {showDims && <th >DIM3</th>}
              </tr>
            </thead>

            <tbody>
              {formatCodeListing.map((r: any) => (
                <tr key={r.code ?? r.codingStr}>

                  <td >{r.codingStr}</td>
                  {!showDims && <td >{r.formatDesc}</td>}
                  {!showDims && <td >{r.partFormat}</td>}
                  {!showDims && <td >{r.mechanicals}</td>}
                  {!showDims && <td >{r.royaltyFormat}</td>}
                  {!showDims && <td >{r.digital}</td>}
                  {!showDims && <td >{r.releaseDesc}</td>}
                  {!showDims && <td >{r.formatReport}</td>}
                  {!showDims && <td >{r.escRateAlbum}</td>}
                  {!showDims && <td >{r.escRateTrack}</td>}

                  {showDims && <td >{r.analysisDim1}</td>}
                  {showDims && <td >{r.analysisDim2}</td>}
                  {showDims && <td >{r.analysisDim3}</td>}

                  <td className="forceSingleLine" style={{ padding: "12px 8px" }}>

                    <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }} className="width140">

                      <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} onClick={() => openEditDrawer(r)}><i className="icon-pencil"> </i></button>
                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(r)}><i className="icon-trash"> </i> </button>

                    </div>
                  </td>
                </tr>
              ))}


            </tbody>
          </table>}

          {formatCount === 0 && <div className="alert alert-info ws-12 box" >No records to display</div>}
        </div>

        {/* Export row */}
        <div className="pagination-export-row ws-12" style={{ marginTop: 12, paddingTop: 8, }}>

          {formatCount > 10 && <div className="ws-10">
            <Pagination totalRow={formatCount} onPageChange={onPageChange} />
          </div>}
        </div>

        {/* Add button */}
        <div className=" ws-12 ws-12" style={{ marginTop: 12, display: "flex", justifyContent: "flex-start", }} >
          <button className="icon-btn primary height35 pull-right fill" type="button" disabled={!editingOn} onClick={() => openAddDrawer({})} >Add Format Codes</button>
        </div>

      </div>

      {(() => {

        if (editDawer === true) {
          return <FormatCodeUpsert editDawer={editDawer} editDataDawer={editDataDawer} closeDrawer={closeDrawer} />
        }

        if (deleteStatus) {
          return <DeleteDialogueBox param={deleteStatus} message={"delete the selected format code " + deleteData?.formatDesc} onChange={deleteConfirmation} />
        }

      })()}

    </>
  );
};